import { UPDATE_APP_DATA } from 'constants/action_types'
import { FETCH_ACCOUNT_SUCCESS } from 'constants/actionTypes/account'

import {
  FETCH_INTEGRATION_SETTINGS_REQUEST,
  FETCH_INTEGRATION_SETTINGS_RESPONSE,
  UPDATE_INTEGRATION_SETTINGS_RESPONSE,
} from '../types'

const initialState = { loaded: false, byProvider: {} }

export default function settingsReducer(
  currentState,
  {
    data,
    meta: { provider } = {},
    payload,
    payload: { account: { integrationSettings: payloadSettings } = {} } = {},
    type,
  }
) {
  const { account: { integrationSettings } = {} } = data || {}
  const state = currentState || initialState
  if (type === FETCH_INTEGRATION_SETTINGS_REQUEST) {
    return {
      ...state,
      loading: true,
    }
  } else if (type === UPDATE_INTEGRATION_SETTINGS_RESPONSE) {
    return {
      ...state,
      byProvider: {
        ...state.byProvider,
        [provider]: payload,
      },
    }
  } else if (
    [
      UPDATE_APP_DATA,
      FETCH_INTEGRATION_SETTINGS_RESPONSE,
      FETCH_ACCOUNT_SUCCESS,
    ].includes(type)
  ) {
    const settings = [FETCH_ACCOUNT_SUCCESS, UPDATE_APP_DATA].includes(type)
      ? integrationSettings || payloadSettings
      : payload
    return {
      ...state,
      loading: false,
      loaded: true,
      byProvider: {
        ...(settings || []).reduce((result, { provider: key, value }) => {
          // eslint-disable-next-line no-param-reassign
          result[key] = value
          return result
        }, {}),
      },
    }
  }
  return state
}
